module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMBAMAAACkW0HUAAAAHlBMVEUAAADMzMzJycnIyMjJycnJycnIyMjKysrJycnJycmOJuixAAAACXRSTlMAD3/D4fb3+Pk5LqaZAAAAL0lEQVQI12OwnDlzMgMDwwQGBk4kynMK58wgCE8CzAMywDxOdB4SJc4ANGzmzCQAbK8O1kINX3AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/commpany_cc.png
// module id = vMe7
// module chunks = 2